import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Scheduling } from "../models/schedule";
import { fetchUserRole } from "../api/fetchUser";
import { fetchConsultantSchedulingsByMonthAndYear } from "../api/fetchScheduling";
import { UserRoleEnum } from "../enums/role";
import { fetchSchedulingsByMonthAndYear } from "../api/fetchScheduling";

function useCalendar() {
  const intl = useIntl();
  const [showCalendar, setShowCalendar] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showDialog, setShowDialog] = useState(false);
  const [schedulingChoosed, setSchedulingChoosed] = useState<Scheduling | null>(null);
  const [loading, setLoading] = useState(true);
  const [monthSchedule, setMonthSchedule] = useState<Scheduling[]>([]);

  const [month, setMonth] = useState<number | undefined>();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const role = await fetchUserRole();
        const month = currentDate.getMonth() + 1;
        setMonth(month);
        const year = currentDate.getFullYear();
        let schedules: Scheduling[] = [];

        if (role === UserRoleEnum.CONSULTANT) {
          schedules = await fetchConsultantSchedulingsByMonthAndYear(
            month,
            year
          );
        } else {
          schedules = await fetchSchedulingsByMonthAndYear(month, year);
        }

        setMonthSchedule(schedules);
      } catch (error) {
        console.error("Erro ao buscar agendamentos:", error);
      } finally {
        setLoading(false);
      }
    };

    if(month !== currentDate.getMonth() + 1) fetchData();
  }, [currentDate]);

  const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);
  const weekdayFormatter = new Intl.DateTimeFormat(intl.locale, { weekday: "narrow" });
  const monthFormatter = new Intl.DateTimeFormat(intl.locale, { month: "short" });
  const daysOfWeek = Array.from({ length: 7 }, (_, index) =>
    weekdayFormatter.format(new Date(2024, 0, index + 1)).toUpperCase()
  );
  const monthNames = Array.from({ length: 12 }, (_, index) =>
    capitalize(monthFormatter.format(new Date(2024, index, 1)).replace(".", ""))
  );

  const changeMonth = async (direction: any) => {
    const newDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + direction,
      1
    );
    setCurrentDate(newDate);
    const schedules = await fetchSchedulingsByMonthAndYear(
      newDate.getMonth() + 1,
      newDate.getFullYear()
    );
    setMonthSchedule(schedules);
  };

  const renderDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty" />);
    }

    for (let date = 1; date <= lastDate; date++) {
      const isToday =
        date === currentDate.getDate() &&
        month === currentDate.getMonth() &&
        year === currentDate.getFullYear();

      const hasScheduling =
        monthSchedule.filter(
          (scheduling) =>
            scheduling.date.getDate() ===
            new Date(year, month, date).getDate()
        ).length > 0;

      days.push(
        <div
          key={date}
          className={`text-size-14 font-weight-normal calendar-day ${isToday ? "today" : ""} ${hasScheduling && !loading ? "bg-scheduling" : ""}`}
          onClick={() => {
            setCurrentDate(new Date(year, month, date));
          }}
        >
          {date}
        </div>
      );
    }

    return days;
  };

  return {
    currentDate,
    showCalendar,
    setShowCalendar,
    showDialog,
    setShowDialog,
    schedulingChoosed,
    setSchedulingChoosed,
    loading,
    monthSchedule,
    changeMonth,
    renderDays,
    daysOfWeek,
    monthNames,
  };
}

export default useCalendar;